import React, { useContext, useEffect, useState } from 'react';

import { DrawerComponent } from 'components/Drawer';
import { api } from 'services/api';
import loadingIcon from 'assets/image/loading.svg';
import * as S from './styles';
import { Line } from 'components/Line';
import moment from 'moment';
import { formatCurrency } from '..';
import { ClientInfoContext } from 'contexts/ClientInfoContext';

interface IDetailsImob {
  closeDrawer: () => void;
  inforImob: any;
}
const DetailsImob = ({ closeDrawer, inforImob }: IDetailsImob) => {
  const [isLoading, setIsLoading] = useState(false);
  const accessToken = localStorage.getItem('accessToken');
  const idToken = localStorage.getItem('idToken');
  const { dataClientInfo } = useContext(ClientInfoContext);

  const [indicators, setIndicators] = useState<any>();
  useEffect(() => {
    const fetchDataChangePlan = async () => {
      setIsLoading(true);
      try {
        const { data } = await api.get(
          `/kernel/additional-users/${dataClientInfo?.id_realstate}
        `,
          {
            headers: {
              'content-Type': 'application/json',
              Authorization: `Bearer ${accessToken}`,
              idToken,
            },
          },
        );
        setIsLoading(false);
        setIndicators(data.data);
      } catch (error) {
        console.log(error);
      }
    };
    dataClientInfo?.id_realstate && fetchDataChangePlan();
  }, [accessToken, idToken, dataClientInfo?.id_realstate]);
  const Loader = () => {
    return (
      <S.Loader>
        <img src={loadingIcon} width={36} height={36} />
      </S.Loader>
    );
  };

  return (
    <DrawerComponent
      open
      size="default"
      // className={styles.drawer}
      onCompleteClose={closeDrawer}
      titleClose={'Detalhes do plano'}
    >
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <S.ContentDetails>
            <S.TextAside
              fontSize="20"
              fontWeight="700"
              style={{ marginBottom: '16px' }}
            >
              {inforImob.planName}
            </S.TextAside>
            <S.Grid>
              <div>
                <S.TextAside fontSize="12" color="#808080">
                  Data de contratação
                </S.TextAside>
                <S.TextAside>
                  {moment(inforImob?.activationDate).format('DD/MM/YYYY')}
                </S.TextAside>
              </div>
              <div>
                <S.TextAside fontSize="12" color="#808080">
                  Data de renovação
                </S.TextAside>
                <S.TextAside>{inforImob?.terminationDate}</S.TextAside>
              </div>
            </S.Grid>
            <S.Grid>
              <div>
                <S.TextAside fontSize="12" color="#808080">
                  Frequência
                </S.TextAside>
                <S.TextAside>{inforImob?.planFrequency}</S.TextAside>
              </div>
              <div>
                <S.TextAside fontSize="12" color="#808080">
                  Valor
                </S.TextAside>
                <S.TextAside>
                  {formatCurrency(inforImob?.installmentValue || 0)}
                </S.TextAside>
              </div>
            </S.Grid>
            <S.TextAside
              fontSize="16"
              fontWeight="500"
              style={{ marginBottom: '24px' }}
            >
              {indicators?.contract_users} Usuários no plano
            </S.TextAside>
            {indicators?.additional_users > 0 && (
              <>
                <Line width="100%" border="1px" />
                <S.TextAside
                  fontSize="20"
                  fontWeight="700"
                  style={{ marginBottom: '16px', marginTop: '24px' }}
                >
                  Usuários adicionais
                </S.TextAside>
                <S.Grid>
                  <div>
                    <S.TextAside fontSize="12" color="#808080">
                      Última atualização
                    </S.TextAside>
                    <S.TextAside>
                      {moment(indicators?.contract_date).format('DD/MM/YYYY')}
                    </S.TextAside>
                  </div>
                  <div>
                    <S.TextAside fontSize="12" color="#808080">
                      Valor
                    </S.TextAside>
                    <S.TextAside>
                      {formatCurrency(
                        indicators?.additional_users * indicators?.unit_value ||
                          0,
                      )}
                    </S.TextAside>
                  </div>
                </S.Grid>
                <S.TextAside fontSize="16" fontWeight="500">
                  {indicators?.additional_users} Usuários adicionais
                </S.TextAside>
              </>
            )}
          </S.ContentDetails>
        </>
      )}
    </DrawerComponent>
  );
};
export default DetailsImob;
